import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';

class CartItem extends Component {
  handleUpdateQuantity = (delta) => {
    const { item, updateQuantity } = this.props;
    updateQuantity(item.id, delta);
  };

  handleRemoveItem = () => {
    const { item, removeItem } = this.props;
    removeItem(item.id);
  };

  render() {
    const { item } = this.props;

    return (
      <tr>
        <td>{item.name}</td>
        <td>{item.price} DT</td>

        <td>
          <Button
            style={{ backgroundColor: '#F5F7F7', borderColor: 'gray' }}
            variant="outline-secondary"
            onClick={() => this.handleUpdateQuantity(-1)}
          >
            -
          </Button>
          {' '}{item.quantity}{' '}
          <Button
            style={{ backgroundColor: '#F5F7F7', borderColor: 'gray' }}
            variant="outline-secondary"
            onClick={() => this.handleUpdateQuantity(1)}
          >
            +
          </Button>
        </td>
        <td>{(item.price * item.quantity).toFixed(2)} DT</td>
        <td>
          <Button
            variant="danger"
            onClick={this.handleRemoveItem}
            style={{ marginLeft: '10px', backgroundColor: '#C62E2E', border: 'none' }}
          >
            <FaTrash />
          </Button>
        </td>
      </tr>
    );
  }
}

export default CartItem;
